import styled from 'styled-components';

export const Container = styled.div`
  button {
      background-color: ${({ checked }) => (checked ? '#56C568' : null)};
  }
`;
